module.exports = __webpack_public_path__ + "static/Foundation Photo 1-02aba0911c3968f621f47d48263ebd44.jpg";